"use client";

import Button from "../SecondaryButton";
import Modal from "./Modal";
import CheckIcon from "@/assets/check-mark.svg";

interface IProps {
  close: () => void;
  isOpen: boolean;
}

const RedeemSuccessfulModal = ({ close, isOpen }: IProps) => {
  return (
    <Modal close={close} isOpen={isOpen} className="w-[90%] md:w-[660px]">
      <div className="flex flex-col gap-7 text-white text-center items-center">
        <div className="flex flex-col gap-4 items-center">
          <div className="flex flex-col gap-8 items-center">
            <CheckIcon className="w-20 h-20" />
            <span className="font-albert-sans text-2xl leading-7 uppercase">
              Redeem Successful
            </span>
          </div>
          <p className="text-[18px] leading-5 font-bold">
            Your $SPON has been successfully redeemed.
          </p>
        </div>

        <Button className="w-max" variant="light" onClick={close}>
          <div className="px-20">CLOSE</div>
        </Button>
      </div>
    </Modal>
  );
};

export default RedeemSuccessfulModal;
